import type { AlpineComponent } from 'alpinejs';

type VideoData = {
  videoType: 'file' | 'youtube' | 'vimeo';
  videoSrc: string;
  autoplay: boolean;
  isEmbedded: boolean;
  hasConsent: boolean;
  hasPoster: boolean;
  onClickPlay: () => void;
  updateHasConsent: () => void;
};

/**
 * ID of the OneTrust cookie consent group that activates videos
 */
const CONSENT_ID = 'C0004';

const Video = (
  videoType: VideoData['videoType'],
  videoSrc: string,
  hasPoster: boolean
): AlpineComponent<VideoData> => ({
  /**
   * Type of the video, e.g. 'file', 'youtube' or 'vimeo'
   */
  videoType: videoType,

  /**
   * Either the file path, the YouTube ID, or the Vimeo ID
   */
  videoSrc: videoSrc,

  /**
   * Whether the player should automatically start playback
   */
  autoplay: false,

  /**
   * Whether the player code is embedded into the website
   */
  isEmbedded: false,

  /**
   * Whether cookie consent is given
   */
  hasConsent: false,

  /**
   * Whether the video has a poster
   */
  hasPoster: hasPoster,

  onClickPlay() {
    window.dispatchEvent(new CustomEvent('Videos.stopAllVideos'));

    window.addEventListener('Videos.stopAllVideos', () => {
      this.isEmbedded = false;
    });

    this.autoplay = true;
    this.isEmbedded = true;
  },

  updateHasConsent() {
    if (window.OnetrustActiveGroups) {
      this.hasConsent = window.OnetrustActiveGroups.includes(CONSENT_ID);
    }
  },

  init() {
    window.addEventListener('consentchanged', () => {
      this.updateHasConsent();
    });
    this.updateHasConsent();

    if (!this.hasPoster) {
      this.isEmbedded = true;
    }
  }
});

export default Video;
